<template>
  <!-- show existing custom formats  -->
  <appPageOptionAttributes
    v-for="(pageOptionAttributes, index) in getCustomFormats"
    :key="index"
    :propsData="pageOptionAttributes"
  ></appPageOptionAttributes>
  <appInputCustomFormatInsert
    v-if="nrItems > 1"
    :ppcode="ppcode"
  ></appInputCustomFormatInsert>
</template>
<script>
import { useCustomStore } from "@/stores/modules/custom";
import { mapState, mapActions } from "pinia";

export default {
  computed: { ...mapState(useCustomStore, ["getCustomFormats"]) },
  props: ["nrItems", "ppcode"]
};
</script>
